import { render } from "./HeaderPage.vue?vue&type=template&id=56996f5d&scoped=true"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"

import "./HeaderPage.vue?vue&type=style&index=0&id=56996f5d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56996f5d"

export default script